import React from "react";
import { ParlorDetailProps } from "../../../types";
import { Box, Stack } from "@mui/material";
import { ColorIcon } from "../../common";
import { colors } from "../../../styles";
import { icon as iconMap } from "../../../constants/icon";

function TrafficSection({
  icon,
  title,
  content,
}: {
  icon: keyof typeof iconMap;
  title: string;
  content: string;
}) {
  const lines = content
    .replace(/\r\n/g, "\n")
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => line.length > 0);

  return (
    <Stack gap="8px">
      <Stack flexDirection="row" alignItems="center" gap="6px">
        <ColorIcon name={icon} size={20} color={colors.warmGray700} />
        <Box className="subtitle_14_sb">{title}</Box>
      </Stack>
      <Stack gap="4px" paddingLeft="26px">
        {lines.map((line, i) => (
          <Box
            key={i}
            className="body_14_r gray700"
            style={{ lineHeight: "1.5" }}
          >
            {line}
          </Box>
        ))}
      </Stack>
    </Stack>
  );
}

export function TrafficInfo({
  defaultParlor,
}: {
  defaultParlor: ParlorDetailProps;
}) {
  const { traffpublic, traffowner } = defaultParlor;

  if (!traffpublic && !traffowner) return null;

  return (
    <Stack padding="20px 20px 24px" gap="16px">
      <Box component="h3" className="button2" margin={0}>
        찾아오시는 길
      </Box>

      {traffpublic && (
        <TrafficSection
          icon="icon-pin-location-mono"
          title="대중교통"
          content={traffpublic}
        />
      )}

      {traffowner && (
        <TrafficSection
          icon="icon-car-solid"
          title="자가용"
          content={traffowner}
        />
      )}
    </Stack>
  );
}
